import { Text } from '@chakra-ui/react'
import { CatalogoBasePage, type ColumnConfig, type FieldConfig } from '../../../components/CatalogoBasePage'
import { tiposVehiculoService } from '../../../api/services'
import type { LookupItem } from '../../../api/models/maestros.models'
import { themeColors } from '../../../theme'

const columns: ColumnConfig<LookupItem>[] = [
  { header: 'ID', render: (i) => <Text fontFamily="monospace" fontSize="sm" color={themeColors.textSecondary}>{i.id}</Text> },
  { header: 'Descripción', render: (i) => <Text fontSize="sm" color={themeColors.text}>{i.description}</Text> },
]

const fields: FieldConfig<LookupItem>[] = [
  { name: 'description', label: 'Descripción', type: 'text', required: true, colSpan: 2 },
]

export default function TiposVehiculoPage() {
  return (
    <CatalogoBasePage<LookupItem, number>
      title="Tipos de Vehículo"
      subtitle="Catálogo de tipos de vehículo (lookup)"
      entityName="tipo de vehículo"
      service={tiposVehiculoService as never}
      columns={columns}
      fields={fields}
      keyExtractor={(i) => String(i.id)}
      idExtractor={(i) => i.id}
      isLookupOnly
      searchPlaceholder="Buscar..."
      updatePermission="masters.write"
    />
  )
}
